module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAAXVBMVEUAAAA5ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez45ez4zUH1sAAAAHnRSTlMA5dwJ6uI/+pEu9NfRl4uGdRjtu044Fg7NqHhtWjZGX5O7AAAAk0lEQVQ4y+3SNw7DMBBE0aGWUZFUdOT9j2mqMGCvDYmtAP1y8MrB2fEiX0jxThZd+M/u8Tu7IDWOjNWMVQ6gruwZU4wpDWpMlIwVjAmN1iS9w6706Fe9zZQLl7jPWvgyg1l0JoPJp1YZLA6zNRlMTPOQwZTGVP2yirHaAbqOJWMtY57S6BrLWGjE55FuC9aIcHa4XnnLH54vP5MOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pageico_3.png
// module id = IcJ/
// module chunks = 1